var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

const SvgFilter = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M3 2h10L7.99 8.3 3 2ZM.25 1.61C2.27 4.2 6 9 6 9v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1V9s3.72-4.8 5.74-7.39A.998.998 0 0 0 14.95 0H1.04C.21 0-.26.95.25 1.61Z",
  fill: "currentColor"
})));

export default SvgFilter;